
<!-- Add Below for NEW UI-->
    <div class="row no-gutters minHeight mobileViewPadding">
        <div class="col-2 col-md-3 col-lg-2" *ngIf="(progressPercentage > 0)">
            <span class="percentagefont ">{{ progressPercentage + '%' }}</span>
        </div>
        <div class="col-10 col-md-9 col-lg-10 centerIndicatorDiv" *ngIf="progressPercentage > 0">
            <div class="progress" id="progressBarContnr">
                <div class="progress-bar" id="progressBarPrcntge" role="progressbar"
                    [style.width]="progressPercentage + '%'" [attr.aria-valuenow]="progressPercentage" aria-valuemin="0"
                    aria-valuemax="100"></div>
            </div>
        </div>
    </div>
    <div class="row no-gutters headingMargin mobileViewPadding bot_spa_aft_mobile_sec_heading">
        <div class="col-12 d-flex align-items-center heading_minHeight_label" id="sidebarTitle" role="heading" aria-level="1"  tabindex="-1">
            <span class="sidebar_head_Txt" >{{ sidebarTitle | translate }}</span>
            <span class="show-for-sr" *ngIf="progressPercentage != 0 && isIos == false">{{' progress '
                +progressPercentage +
                '%'}}
            </span>
        </div>
    </div>
